import "./ContactScreen.css";

export default function ContactScreen({ email }) {
  return (
    <section className="section" id="contact">
      <div className="sectionHeader">
        <div className="sectionNum">06.</div>
        <div className="sectionTitle">Get in touch</div>
      </div>

      <p className="muted contactText">
        Currently open to new opportunities and collaborations. Let’s build the future together.
      </p>

      <a className="bigMail" href={`mailto:${email}`}>
        {email} <span className="arrow">→</span>
      </a>
    </section>
  );
}
